function App() {
  return (
    <div className="w-full h-screen bg-gradient-to-b from-cyan-500 to-blue-500">
      <h1 className="text-3xl animate-bounce h-full font-bold text-white flex items-center justify-center">
        <div className="animate-spin">
          Hello World!
        </div>
      </h1>
    </div>
  );
}

export default App;
